// extracted by mini-css-extract-plugin
export default {"hologram":"styles_hologram__sbdXS","title":"styles_title__cagC0"};